// Cálculo invertido de costes de un recurso.
// Entrada: coste de compra CON IVA (bruto). Salida: neto, IVA y cadena de márgenes.
export function computeCosts({ gross = 0, vat = 21, safetyPct = 15, salePct = 25 } = {}) {
  const g = Number(gross) || 0;
  const v = Number(vat) || 0;
  const s = Number(safetyPct) || 0;
  const sv = Number(salePct) || 0;
  const net = v ? g / (1 + v / 100) : g;
  const vatAmount = g - net;
  const safetyAmount = (g * s) / 100;
  const internal = g + safetyAmount;
  const saleAmount = (internal * sv) / 100;
  const salePrice = internal + saleAmount;
  return { gross: g, net, vatAmount, safetyPct: s, safetyAmount, internal, salePct: sv, saleAmount, salePrice };
}
